import React from 'react';
import { useNavigate } from 'react-router-dom';
import { services, trustPoints, siteConfig } from '../mock';
import { useBooking } from '../hooks/useBooking';
import useSEO from '../hooks/useSEO';
import { Check, ChevronRight } from 'lucide-react';

const Home = () => {
  useSEO({
    title: 'Prestige Beauty & Wellness — LPG kehahooldused Pärnus',
    description:
      'LPG Alliance kehahooldused, kavitatsioon, RF lifting, inframatt ja klassikaline massaaž Pärnu südames. Ilu, heaolu ja harmoonia — broneeri aeg juba täna.',
    path: '/',
  });
  const navigate = useNavigate();
  const openBooking = useBooking();

  return (
    <div>
      {/* HERO */}
      <section
        className="marble-hero relative min-h-screen flex items-center justify-center px-4 sm:px-6 pt-28 pb-16"
        style={{ backgroundImage: 'none', backgroundColor: '#ffffff' }}
      >
        <div className="relative z-10 flex flex-col items-center text-center max-w-4xl w-full">
          <div className="hero-logo-photo-wrap fade-up">
            <img
              src={siteConfig.heroImage}
              alt="PRESTIGE Beauty & Wellness"
              className="hero-logo-photo select-none"
              draggable="false"
              loading="eager"
              decoding="async"
              width={1254}
              height={1254}
            />
          </div>

          <div className="hero-eyebrow-refined mt-14 fade-up fade-up-delay-1">
            Ilu. Heaolu. Harmoonia.
          </div>

          <h2 className="hero-tagline mt-10 fade-up fade-up-delay-2">
            Ajatu ilu algab professionaalsest hoolitsusest.
          </h2>
          <p className="hero-tagline-sub mt-6 fade-up fade-up-delay-2">
            Maailmas tunnustatud tehnoloogia, rahvusvaheliselt koolitatud
            spetsialistid ja personaalne lähenemine igale kliendile.
          </p>

          <div className="hero-eyebrow-refined mt-14 fade-up fade-up-delay-2">
            Pärnu südames
          </div>

          <div className="hero-cta-row mt-14 fade-up fade-up-delay-3">
            <button className="btn-gold" onClick={openBooking}>
              Broneeri aeg
            </button>
            <button className="btn-ghost-gold" onClick={() => navigate('/teenused')}>
              Tutvu teenustega
            </button>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="bg-ivory py-28 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <div className="section-eyebrow">Meie teenused</div>
          <h2 className="section-title text-4xl md:text-5xl mt-4">Kehahooldus täiuslikkuseni</h2>
          <div className="mt-6 flex justify-center"><span className="gold-divider" /></div>
          <p className="text-brand-muted mt-8 max-w-2xl mx-auto">
            Professionaalsed kehahoolduse teenused, mis ühendavad teaduspõhist
            tehnoloogiat ja lõõgastava spa-kogemuse.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-20 mt-20">
            {services.map((s) => (
              <div key={s.id} className="flex flex-col items-center px-4">
                <div className="service-image-circle">
                  <img src={s.image} alt={s.title} />
                </div>
                <h3 className="font-serif-display text-2xl text-brand mt-10">{s.title}</h3>
                <p className="text-brand-muted mt-4 max-w-md">{s.short}</p>
                <button onClick={() => navigate(`/teenused#${s.id}`)} className="link-underline mt-8">
                  Loe lähemalt <ChevronRight className="w-3.5 h-3.5" strokeWidth={1.5} />
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TRUST */}
      <section className="bg-ivory-2 py-28 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center">
            <div className="section-eyebrow">Meie lähenemine</div>
            <h2 className="section-title text-3xl md:text-4xl mt-4">
              Miks kliendid usaldavad meid
            </h2>
            <div className="mt-6 flex justify-center"><span className="gold-divider" /></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-14 gap-y-10 mt-16">
            {trustPoints.map((point, idx) => (
              <div key={idx} className="flex gap-5">
                <div className="feature-icon">
                  <Check className="w-4 h-4" strokeWidth={2} />
                </div>
                <div>
                  <h3 className="text-brand text-lg font-serif-display">{point.title}</h3>
                  <p className="text-brand-muted mt-2">{point.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-ivory py-28 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="font-serif-display text-3xl md:text-4xl text-brand">
            Küsimuste korral oleme teie jaoks olemas
          </h2>
          <div className="mt-6 flex justify-center"><span className="gold-divider" /></div>
          <button className="btn-gold mt-10" onClick={() => navigate('/kontakt')}>
            Võta ühendust
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
